<template>
  <Form
    class="flex flex-col gap-6 w-full"
    :resolver="mediaResolver"
    :initialValues="initialValues"
    ref="mediaForm"
    v-slot="$form"
    v-focustrap
    data-test="media-form"
  >
    <LabeledField :field="$form.images">
      <FormField
        v-slot="$field"
        name="images"
      >
        <ImageUpload
          auto
          multi
          :minSize="400"
          :maxSize="1600"
          :value="$field"
          @uploaded="
            (data) => {
              $form.images.value = data;
            }
          "
          data-test="image-upload"
        />
      </FormField>
    </LabeledField>
  </Form>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { z } from 'zod';
import { zodResolver } from '@primevue/forms/resolvers/zod';
import { useCompanyAdminStore } from '@/stores/CompanyAdminStore.js';
import ImageUpload from '@/components/forms/ImageUpload.vue';
import LabeledField from '@/components/forms/LabeledField.vue';

const mediaForm = ref(null);
const mediaResolver = zodResolver(
  z.object({
    images: z.array(z.string().nullable()),
  }),
);

const companyAdminStore = useCompanyAdminStore();

const initialValues = computed(() => ({
  images: companyAdminStore.company.images,
}));

onMounted(() => {
  companyAdminStore.mediaForm = mediaForm.value;
});
</script>
